import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import PWAPrompt from './components/PWAPrompt';
import {
  setUpdateSW, watchServiceWorkerUpdates, onNeedReload, markSwUpdateAvailable,
} from './lib/swUpdate';
import './index.css';

// Register the service worker (was auto-injected before) and expose updateSW so
// the version-gate reload paths can ACTIVATE a newly-deployed SW instead of a
// plain reload the old SW serves from stale precache. See lib/swUpdate.
//
// onNeedReload is NOT optional. Without it the plugin reloads the page itself
// the moment a new worker takes control — no warning, unsaved work gone. Once
// the worker takes control on install (phase 2, vite.config.ts) that would
// fire in every open tab on every release.
setUpdateSW(registerSW({ immediate: true, onNeedReload }));

/* A tab open across a release asks for a code chunk the new build no longer
   has — the zip export, the payslip bundle. The screen shows its own error;
   this raises the banner too, so the person knows a reload fixes it rather
   than reporting the export as broken. Never reloads by itself. */
window.addEventListener('vite:preloadError', () => markSwUpdateAvailable());
// Detect new deploys straight from the service worker (no Firestore/ADC needed)
// so the version gate works even when the build-id publish step is unavailable.
watchServiceWorkerUpdates();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
    <PWAPrompt />
  </React.StrictMode>,
);
